"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get AuthService () {
        return AuthService;
    },
    get CreateUserDto () {
        return CreateUserDto;
    }
});
const _util = require("util");
const _nocodbsdk = require("nocodb-sdk");
const _common = require("@nestjs/common");
const _bcryptjs = /*#__PURE__*/ _interop_require_wildcard(require("bcryptjs"));
const _Noco = /*#__PURE__*/ _interop_require_default(require("~/Noco"));
const _helpers = require("~/services/users/helpers");
const _usersservice = require("~/services/users/users.service");
const _ncError = require("~/helpers/ncError");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {
        __proto__: null
    };
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys = Object.getOwnPropertyNames(source), key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
    }
    return target;
}
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
let CreateUserDto = class CreateUserDto {
};
let AuthService = class AuthService {
    async validateUser(email, pass) {
        const user = await this.usersService.findOne(email);
        if (user) {
            const { password, salt } = user, result = _object_without_properties_loose(user, [
                "password",
                "salt"
            ]);
            // `salt` will be null,
            // 1. If the user is invited and yet to set password
            // 2. If the user is created via non email-password auth (OAuth)
            if (!user.salt) {
                return _ncError.NcError.badRequest('If invited, sign up via the email link; otherwise, use forgot password or contact the super admin.');
            }
            const hashedPassword = await (0, _util.promisify)(_bcryptjs.hash)(pass, user.salt);
            if (user.password === hashedPassword) {
                return result;
            }
        }
        return null;
    }
    async login(user) {
        delete user.password;
        delete user.salt;
        const payload = user;
        return {
            token: (0, _helpers.genJwt)(payload, _Noco.default.getConfig())
        };
    }
    async registerNewUserIfAllowed({ firstname, lastname, email, salt, password, email_verification_token }, ncMeta = _Noco.default.ncMeta) {
        const roles = _nocodbsdk.OrgUserRoles.CREATOR;
        const token_version = ''; // randomTokenString();
        return await this.usersService.insert({
            firstname,
            lastname,
            email,
            salt,
            password,
            email_verification_token,
            roles,
            token_version
        }, ncMeta);
    }
    constructor(usersService){
        this.usersService = usersService;
    }
};
AuthService = _ts_decorate([
    (0, _common.Injectable)(),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _usersservice.UsersService === "undefined" ? Object : _usersservice.UsersService
    ])
], AuthService);
